import * as tslib_1 from "tslib";
import styled from '../styles';
import { getColorFromTheme } from '../utils/colors';
var BorderlessSelectWrapper = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  position: relative;\n  color: ", ";\n"], ["\n  display: inline-flex;\n  position: relative;\n  color: ",
    ";\n"])), function (props) {
    return getColorFromTheme(props, props.error
        ? props.theme.palette.error[500]
        : props.theme.palette.text.primary);
});
export default BorderlessSelectWrapper;
var templateObject_1;
//# sourceMappingURL=BorderlessSelectContent.js.map